import { Icon } from '@iconify/react';
import classnames from "classnames";
import Styles from "./styles.module.scss";
import ellowLogo from "../../assets/images/ellow-logo.svg";
import pageGraphics from "../../assets/images/comingsoon.svg";
import { useEffect, useState } from 'react';
import { updateCandidateStatus } from './services';
import { useNavigate } from 'react-router-dom'
import acceptedImage from '../../assets/images/thankyou-graphics.svg';
// import rejectImage from '../../assets/images/thankyou-rejected-graphics (1).svg'
import rejectImage from '../../assets/images/thankyou-rejected-graphics (1).svg'
import { viewedpageMixpanel } from '../../utils/mixpanel';

function PageStatus() {
  
  const navigate = useNavigate()
  const userLoginId = localStorage.getItem('loginId')
  const [message , setMessage] = useState<string>()
  const [rejected, setRejected] = useState<boolean>()
    
  useEffect(() => {

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const status: any  = urlParams.get('status')  
  const candidateId: any = urlParams.get('candidateId')
  const jobId: any = urlParams.get('jobId')
  const userName: any = urlParams.get('name')?.replace('%20',' ')
    
  if(status === '1'){
    setMessage(`Our Recruiters will immediately inform ${userName} about the interview`) 
    setRejected(false)
  }
  else if(status === '2'){
    setMessage(`You have rejected ${userName} from your screening process :(`)
    setRejected(true)
  }else{
     setMessage("Cannot process the request since this action is already taken")
  }
    getCandidateStatus(status, candidateId, jobId)
    viewedpageMixpanel();

  },[]);

  
  const getCandidateStatus = (status : string , candidateId : string , jobId : string) => {
    let data = {
        "loginId" : candidateId,
        "positionStatus" : status === '1' ? "2" : "3",
        "userLoginId" : userLoginId,
        "jobId": jobId
    }
    updateCandidateStatus(data).then((resp: any) => {

    })
  }
  
  const goHome = () => {
    navigate('/login')
  }
  
  return (
    <section className={Styles.errorWrap}>
      <img src={ellowLogo} alt="Ellow" className={Styles.logo} />
      <div className={Styles.errorMessage}>
        <img src={rejected ? rejectImage : acceptedImage}/>
        <h1>Thank You!</h1>
        <p style={{"color": rejected ? "red" : "black"}}>{message}</p>
        <a onClick={goHome} className={Styles.link}>Click here to go home</a>
      </div>
    </section>
  )
}


export default PageStatus